export const REQUEST_ALLTRIMCLIPS = 'REQUEST_ALLTRIMCLIPS';
export const ALLTRIMCLIPS_RECEIVED = 'ALLTRIMCLIPS_RECEIVED';
